const runtimeEnv
    = typeof window !== 'undefined' && window.config ? window.config : {};

const mode
    = runtimeEnv.environment
        || import.meta.env.VITE_MODE
        || import.meta.env.MODE
        || 'development';

let cfg = {
    apiBranch:
        runtimeEnv.apiBranch
        || import.meta.env.VITE_API_BRANCH
        || 'main',
    environment: mode,
};

if (typeof config !== 'undefined') {
    cfg = { ...cfg, ...config };
}

const urlConfig = {

    // Разработка
    development: {
        api: import.meta.env.VITE_API_URL,
    },

    // Продакшн
    production: {
        api: '/api',
    },

    // Веточки
    testing: {
        api: `https://crm-api-${cfg.apiBranch}-kl-kube.kolesa-team.org`,
    },
};

// Конфигурация приложения
export default {
    environment: cfg.environment,
    ...urlConfig[cfg.environment],
};
